import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import Link from '../utils/router/Link';
import postPath from '../utils/url/postPath';
import userPath from '../utils/url/userPath';
import Activity from './Activity';
import ActivityCommentCard from './ActivityCommentCard';
import activitiesPostTopics from './activitiesPostTopics';

const ACTIVITY_CREATED_COMMENT_ACTIVITY_FRAGMENT = gql(`
  fragment ActivityCreatedComment_activity on CreatedCommentActivity {
    actedAt
    actor {
      ...useGetUser_user
    }
    createdComment {
      id
      ...ActivityCommentCard_comment
      # eslint-disable-next-line @graphql-eslint/require-selections
      thread {
        post {
          id
          ...postPath_post
          topics {
            ...activitiesPostTopics_topics
          }
        }
      }
    }
  }
`);

interface ActivityCreatedCommentProps {
  activity: DocumentType<typeof ACTIVITY_CREATED_COMMENT_ACTIVITY_FRAGMENT>;
}

const ActivityCreatedComment = ({ activity }: ActivityCreatedCommentProps) => {
  const { actedAt, createdComment } = activity;

  const getUser = useGetUser();

  if (!activity.actor) {
    return null;
  }

  const post = createdComment?.thread?.post;
  const path = post && postPath(post);
  const actor = getUser(activity.actor);

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="COMMENT_CREATE"
      title={
        <>
          <Link to={userPath(actor)}>{actor?.name}</Link> commented on{' '}
          {path && <Link to={path}> {post?.title}</Link>}
        </>
      }
      meta={activitiesPostTopics(post ? post.topics : null)}
    >
      {createdComment && <ActivityCommentCard comment={createdComment} />}
    </Activity>
  );
};

export default ActivityCreatedComment;
